import {createAction} from "redux-act";
import {ApiError} from "modules/utils/Api";

export const setGlobalPreloaderState = createAction<boolean>();

export const fetchEntryData = createAction();
export const fetchEntryDataSuccess = createAction();
export const fetchEntryDataError = createAction<ApiError>();
